export default "__VITE_PUBLIC_ASSET__914c7303__"